export default {"src":"/_next/static/media/mock_dummy_grid_menu.46ed5ff2.svg","height":226,"width":324,"blurWidth":0,"blurHeight":0};